// Module
var code = `<ngx-wizard-view class="course-payment-wizard-view" [title]="\$ctrl.title"><ngx-course-payment-wall (on-credit)="\$ctrl.useCredit()" (on-pay)="\$ctrl.goToPayForm(\$event)"></ngx-course-payment-wall></ngx-wizard-view>`;
// Exports
export default code;